/**
 * addit Theme — Product Page JavaScript
 * Image gallery, subscription toggle, quantity controls, AJAX cart
 */

(function () {
  'use strict';

  /* ==========================================================================
     Image Gallery
     ========================================================================== */
  function initGallery() {
    const gallery = document.querySelector('[data-product-gallery]');
    if (!gallery) return;

    const mainImage = gallery.querySelector('[data-main-image]');
    const thumbs = gallery.querySelectorAll('[data-thumb-index]');
    if (!mainImage || !thumbs.length) return;

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const imageUrl = thumb.dataset.imageUrl;
        if (!imageUrl) return;

        mainImage.src = imageUrl;
        thumbs.forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  }

  /* ==========================================================================
     Subscription Toggle
     ========================================================================== */
  function initSubscriptionToggle() {
    const toggle = document.querySelector('[data-subscription-toggle]');
    if (!toggle) return;

    const options = toggle.querySelectorAll('[data-purchase-type]');
    const sellingPlanInput = toggle.querySelector('[data-selling-plan-input]');
    const intervalSelector = toggle.querySelector('[data-interval-selector]');
    const pills = toggle.querySelectorAll('[data-selling-plan-id]');
    const priceDisplay = document.querySelector('[data-price]');

    options.forEach((option) => {
      option.addEventListener('click', () => {
        const type = option.dataset.purchaseType;

        // Update radio states
        options.forEach((opt) => {
          opt.setAttribute('aria-pressed', 'false');
          opt.querySelector('.subscription-toggle__radio').classList.remove('is-active');
        });
        option.setAttribute('aria-pressed', 'true');
        option.querySelector('.subscription-toggle__radio').classList.add('is-active');

        if (type === 'subscription') {
          // Show interval selector
          if (intervalSelector) intervalSelector.hidden = false;

          // Set selling plan to first active pill
          const activePill = toggle.querySelector('.subscription-toggle__pill.is-active');
          if (activePill && sellingPlanInput) {
            sellingPlanInput.value = activePill.dataset.sellingPlanId;
          }

          // Update displayed price to subscription price
          const subPrice = toggle.querySelector('[data-subscription-price]');
          if (subPrice && priceDisplay) {
            priceDisplay.textContent = subPrice.textContent;
          }
        } else {
          // One-time purchase
          if (intervalSelector) intervalSelector.hidden = true;
          if (sellingPlanInput) sellingPlanInput.value = '';

          // Update displayed price to one-time price
          const oneTimePrice = toggle.querySelector('[data-one-time-price]');
          if (oneTimePrice && priceDisplay) {
            priceDisplay.textContent = oneTimePrice.textContent;
          }
        }

        updateCartTotal();
      });
    });

    // Interval pill selection
    pills.forEach((pill) => {
      pill.addEventListener('click', () => {
        pills.forEach((p) => p.classList.remove('is-active'));
        pill.classList.add('is-active');
        if (sellingPlanInput) {
          sellingPlanInput.value = pill.dataset.sellingPlanId;
        }
      });
    });
  }

  /* ==========================================================================
     Variant Pill Selector
     ========================================================================== */
  function initVariantPills() {
    const pillGroups = document.querySelectorAll('.product-main__pills');
    if (!pillGroups.length) return;

    const variantDataEl = document.getElementById('product-variants-json');
    if (!variantDataEl) return;

    const variants = JSON.parse(variantDataEl.textContent);
    const variantInput = document.querySelector('input[name="id"]');

    // Track currently selected value per option index
    const selectedOptions = {};
    pillGroups.forEach((group) => {
      const index = parseInt(group.dataset.optionIndex);
      const active = group.querySelector('.product-main__pill.is-active');
      selectedOptions[index] = active ? active.dataset.value : group.querySelector('.product-main__pill').dataset.value;
    });

    function findVariant() {
      return variants.find((v) =>
        v.options.every((opt, i) => opt === selectedOptions[i])
      );
    }

    function updateVariant() {
      const variant = findVariant();
      if (!variant) return;

      // Update hidden variant ID
      if (variantInput) variantInput.value = variant.id;

      // Update price display
      const priceEl = document.querySelector('[data-price]');
      if (priceEl) {
        const formatted = (variant.price / 100).toLocaleString('de-DE', {
          style: 'currency',
          currency: 'EUR',
        });
        priceEl.textContent = formatted;
      }

      // Update ATC button availability
      const atcBtn = document.querySelector('[data-add-to-cart]');
      if (atcBtn) atcBtn.disabled = !variant.available;

      // Re-sync cart total display
      updateCartTotal();
    }

    pillGroups.forEach((group) => {
      const index = parseInt(group.dataset.optionIndex);
      const pills = group.querySelectorAll('.product-main__pill');
      pills.forEach((pill) => {
        pill.addEventListener('click', () => {
          pills.forEach((p) => {
            p.classList.remove('is-active');
            p.setAttribute('aria-pressed', 'false');
          });
          pill.classList.add('is-active');
          pill.setAttribute('aria-pressed', 'true');
          selectedOptions[index] = pill.dataset.value;
          updateVariant();
        });
      });
    });
  }

  /* ==========================================================================
     Quantity Controls
     ========================================================================== */
  function initQuantityControls() {
    const decrease = document.querySelector('[data-qty-decrease]');
    const increase = document.querySelector('[data-qty-increase]');
    const input = document.querySelector('[data-qty-input]');
    if (!decrease || !increase || !input) return;

    decrease.addEventListener('click', () => {
      const current = parseInt(input.value) || 1;
      if (current > 1) {
        input.value = current - 1;
        updateCartTotal();
      }
    });

    increase.addEventListener('click', () => {
      const current = parseInt(input.value) || 1;
      if (current < 99) {
        input.value = current + 1;
        updateCartTotal();
      }
    });

    input.addEventListener('change', () => {
      let value = parseInt(input.value) || 1;
      value = Math.max(1, Math.min(99, value));
      input.value = value;
      updateCartTotal();
    });
  }

  /* ==========================================================================
     Update Cart Total Display
     ========================================================================== */
  function updateCartTotal() {
    const priceEl = document.querySelector('[data-price]');
    const totalEl = document.querySelector('[data-cart-total]');
    const qtyInput = document.querySelector('[data-qty-input]');
    if (!priceEl || !totalEl || !qtyInput) return;

    // Simple text update — actual price calculation happens server-side
    const qty = parseInt(qtyInput.value) || 1;
    if (qty === 1) {
      totalEl.textContent = priceEl.textContent;
    } else {
      totalEl.textContent = qty + 'x ' + priceEl.textContent;
    }
  }

  /* ==========================================================================
     AJAX Add to Cart (standard + bundle)
     ========================================================================== */
  function initAjaxCart() {
    const form = document.querySelector('[data-product-info] form');
    if (!form) return;

    /* Bundle detection: look for the JSON data block output by bundle-contents snippet */
    const bundleDataEl = form.querySelector('[id^="bundle-data-"]');
    const isBundle = !!bundleDataEl;
    if (isBundle) {
      const bundleData = JSON.parse(bundleDataEl.textContent);
      form.dataset.bundleProduct = '';
      form.dataset.bundleId = bundleData.bundleId;
      form.dataset.bundleTitle = bundleData.bundleTitle;
      form.dataset.bundleComponents = JSON.stringify(bundleData.components);
    }

    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      const button = form.querySelector('[data-add-to-cart]');
      const stickyBtn = document.querySelector('[data-sticky-atc]');
      if (!button || button.disabled) return;

      const originalBtnHtml = button.innerHTML;
      const originalStickyHtml = stickyBtn ? stickyBtn.innerHTML : null;

      button.disabled = true;
      button.innerHTML = '<span>Wird hinzugefügt...</span>';
      if (stickyBtn) {
        stickyBtn.disabled = true;
        stickyBtn.innerHTML = '<span>Wird hinzugefügt...</span>';
      }

      try {
        if (isBundle) {
          await addBundleToCart(form);
        } else {
          await addSingleToCart(form);
        }

        // Open the cart drawer. Its refresh also sets the header count, as the logical count (a set
        // counts once). Writing cart.js item_count here first flashed "2" for one Starter Set (cc-12).
        if (window.CartDrawer) {
          window.CartDrawer.open(true);
        }

        button.innerHTML = '<span>Hinzugefügt ✓</span>';
        if (stickyBtn) stickyBtn.innerHTML = '<span>Hinzugefügt ✓</span>';
        setTimeout(() => {
          button.innerHTML = originalBtnHtml;
          button.disabled = false;
          if (stickyBtn) {
            stickyBtn.innerHTML = originalStickyHtml;
            stickyBtn.disabled = false;
          }
        }, 1500);
      } catch (error) {
        console.error('Add to cart error:', error);
        if (error && error.handled && window.CartDrawer) {
          /* Cap (or other handled) case — show it inside the cart, not a browser alert */
          window.CartDrawer.open(true);
          if (window.CartDrawer.notify) window.CartDrawer.notify(error.message);
        } else {
          alert(error.message || 'Fehler beim Hinzufügen. Bitte versuche es erneut.');
        }
        button.innerHTML = originalBtnHtml;
        button.disabled = false;
        if (stickyBtn) {
          stickyBtn.innerHTML = originalStickyHtml;
          stickyBtn.disabled = false;
        }
      }
    });
  }

  /* Standard single-product add to cart */
  async function addSingleToCart(form) {
    const formData = new FormData(form);
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
    });
    if (!response.ok) {
      const err = await response.json();
      throw new Error(err.description || 'Fehler beim Hinzufügen');
    }
  }

  /* Bundle add to cart — adds component products as individual line items */
  async function addBundleToCart(form) {
    const componentData = JSON.parse(form.dataset.bundleComponents);
    const bundleId = form.dataset.bundleId;
    const bundleTitle = form.dataset.bundleTitle;
    const bundleDataEl = form.querySelector('[id^="bundle-data-"]');
    const bundleData = bundleDataEl ? JSON.parse(bundleDataEl.textContent) : {};
    const bundlePrice = bundleData.bundlePrice ?? null;
    const deliveryDate = bundleData.deliveryDate || '';
    const qtyEl = form.querySelector('[data-qty-input]') || form.querySelector('input[name="quantity"]');
    const qty = parseInt(qtyEl?.value) || 1;

    /* Per-order cap: block re-adding a capped bundle that is already in the cart (max=1 use case) */
    const maxQuantity = parseInt(bundleData.maxQuantity, 10) || 0;
    if (maxQuantity === 1) {
      const capCheck = await (await fetch('/cart.js')).json();
      const already = capCheck.items.some(function (it) {
        return it.properties && it.properties['_bundle_id'] === bundleId;
      });
      if (already) {
        const capErr = new Error(bundleTitle + ' kann nur einmal pro Bestellung gekauft werden.');
        capErr.handled = true;
        throw capErr;
      }
    }

    const properties = {
      '_bundle_id': bundleId,
      '_bundle_title': bundleTitle,
      '_bundle_price': bundlePrice ? String(bundlePrice) : '',
    };
    if (deliveryDate) properties['_Liefertermin'] = deliveryDate;

    const items = componentData.map(item => ({
      id: item.variantId,
      quantity: item.quantity * qty,
      properties,
    }));

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items }),
    });

    if (!response.ok) {
      const err = await response.json();
      throw new Error(err.description || 'Das Set konnte nicht hinzugefügt werden');
    }
  }

  /* ==========================================================================
     Sticky Add-to-Cart Bar
     ========================================================================== */
  function initStickyBar() {
    const bar = document.getElementById('product-sticky-bar');
    const mainBtn = document.querySelector('[data-add-to-cart]');
    const stickyBtn = document.querySelector('[data-sticky-atc]');
    const stickyPrice = document.querySelector('[data-sticky-price]');
    const mainPrice = document.querySelector('[data-price]');

    if (!bar || !mainBtn) return;

    // Keep sticky price in sync with main price (subscription toggle changes it)
    function syncPrice() {
      if (stickyPrice && mainPrice) {
        stickyPrice.textContent = mainPrice.textContent;
      }
    }
    syncPrice();

    if (mainPrice) {
      new MutationObserver(syncPrice).observe(mainPrice, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    // Section setting "Show the sticky bar from page load" (data-sticky-from-load, 29 Sep): the bar shows
    // from load and hides only while the main button is fully visible below the sticky header, so one
    // button is always in view and never two. The rule is symmetric (above and below the window both
    // count as "not fully visible"), so an IntersectionObserver is safe here; its top margin is the sticky
    // header's height, read at runtime and again after a resize.
    if (bar.hasAttribute('data-sticky-from-load') && 'IntersectionObserver' in window) {
      const headerHeight = () => {
        const header = document.querySelector('.section-header') || document.querySelector('.launch-header');
        if (!header) return 0;
        const pos = getComputedStyle(header).position;
        return pos === 'sticky' || pos === 'fixed' ? Math.round(header.getBoundingClientRect().height) : 0;
      };
      let observer = null;
      let observedTop = -1;
      const observe = () => {
        const top = headerHeight();
        if (observer && top === observedTop) return;
        if (observer) observer.disconnect();
        observedTop = top;
        observer = new IntersectionObserver((entries) => {
          const entry = entries[entries.length - 1];
          const fully = entry.isIntersecting && entry.intersectionRatio >= 0.99;
          bar.classList.toggle('is-visible', !fully);
          bar.setAttribute('aria-hidden', String(fully));
        }, { rootMargin: `-${top}px 0px 0px 0px`, threshold: [0, 0.5, 0.99, 1] });
        observer.observe(mainBtn);
      };
      // The page ends above the bar: its height pads the body (CSS reads --pm-bar-h).
      const pad = () => {
        document.body.style.setProperty('--pm-bar-h', bar.offsetHeight + 'px');
      };
      observe();
      pad();
      let resizeTimer = null;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          observe();
          pad();
        }, 150);
      });
      if (stickyBtn) {
        stickyBtn.addEventListener('click', () => {
          mainBtn.click();
        });
      }
      return;
    }

    // Show the bar once the main button has scrolled ABOVE the viewport — not while it is
    // still below the fold on load, where it covered the buy box (design review F15).
    // A scroll check, not an IntersectionObserver: a jump from above the button to below it
    // never crosses the viewport, so the observer would leave the bar showing.
    let ticking = false;
    const updateBar = () => {
      ticking = false;
      const passed = mainBtn.getBoundingClientRect().bottom < 0;
      bar.classList.toggle('is-visible', passed);
      bar.setAttribute('aria-hidden', String(!passed));
    };
    window.addEventListener('scroll', () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(updateBar);
      }
    }, { passive: true });
    window.addEventListener('resize', updateBar);
    updateBar();

    // Sticky button submits the main product form
    if (stickyBtn) {
      stickyBtn.addEventListener('click', () => {
        mainBtn.click();
      });
    }
  }

  /* ==========================================================================
     Initialize
     ========================================================================== */
  document.addEventListener('DOMContentLoaded', () => {
    initGallery();
    initVariantPills();
    initSubscriptionToggle();
    initQuantityControls();
    initAjaxCart();
    initStickyBar();
  });
})();
